import moment from 'moment'
import { API_DATE_FORMAT, VUETIFY_DATE_FORMAT } from '../const'

export default function transformToApiFormatDate(date) {
  if (!date) {
    return null
  }

  if (typeof date === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.exec(date)) {
    return date
  }

  return moment(date, VUETIFY_DATE_FORMAT).format(API_DATE_FORMAT)
}
